import React from 'react';
import { Box, Typography, Theme } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/styles';
import { ActivityTagsSection } from './ActivityTagsSection';
import { VolunteerTagsSection } from './VolunteerTagsSection';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      paddingLeft: 40,
      paddingRight: 40,
      paddingTop: 20,
      backgroundColor: '#F9F9F9',
      minHeight: 'calc(100% - 20px)',
    },
    heading: {
      alignItems: 'center',
      paddingBottom: '8px',
      borderBottom: '1px solid #efefef',
    },
    headingTitle: {
      color: theme.color.grey.neutralBrand900,
      fontWeight: 600,
      paddingBottom: '5px',
      fontSize: 20,
    },
  })
);

export function AdminConsoleTags() {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.heading}>
        <Typography variant='h2' className={classes.headingTitle}>
          Tags
        </Typography>
        <Typography variant={'body2'}>
          {'Manage the tags you use to categorise activities and segment your volunteers'}
        </Typography>
      </Box>
      <ActivityTagsSection />
      <VolunteerTagsSection />
    </Box>
  );
}
